import { User } from '@/types/user';
import type { EntitlementsStatus } from '@/lib/copilot-access';

export interface UserAuthState {
  isLoaded?: boolean;
  isSignedIn?: boolean;
  isLoggingOut?: boolean;
  user?: User;
  screens?: string[];
  features?: string[];
  screensLoaded?: boolean;
  entitlementsStatus: EntitlementsStatus;
  entitlementsWorkspaceId?: string;
}

export const initialAuthState: UserAuthState = {
  screens: [],
  features: [],
  screensLoaded: false,
  entitlementsStatus: 'idle',
  isLoggingOut: false,
};
